import store from "../store";
import router from "../router";
import qs from "qs";

//获取权限
export function getPermissions() {
  return new Promise((resolve, reject) => {
    this.$http
      .get("/sys/permissions")
      .then(({ data }) => {
        this.$store.commit("Login", {
          permission: data && data.code === 0 ? data.permissions : [],
        });
        resolve(data);
      })
      .catch((err) => {
        resolve([]);
      });
  });
}

//获取用户信息
export function getUserInfo() {
  return new Promise((resolve, reject) => {
    this.$http.post("/sys/user/info").then(({ data }) => {
      if (data.code == 0) {
        this.$store.commit("Login", {
          user: data.user,
        });
        resolve(data.user);
        return;
      }
      this.$toast(data.msg);
      store.commit("Logout");
      router.push({
        name: "agent-login",
      });
    });
  });
}

//获取用户代理
export function getUserAgent(page, limit = 20) {
  return new Promise((resolve, reject) => {
    this.$http
      .get(
        "/sys/agent/list",
        {
          params: {
            page,
            limit,
            // mobile:'13674128523'
          },
        },
        {
          noLoading: true,
        }
      )
      .then(({ data }) => {
        if (data.code == 0) {
          resolve(data);
          return;
        }
        this.$toast(data.msg);
        resolve({
          count: 0,
          data: [],
        });
      });
  });
}

export const industryTypeText = [
  // {id:1,name:'渠道用户',disabled:!this.$hasPermission('sys:agent:industry')},
  { id: 2, name: "安防行业" },
  { id: 3, name: "教育行业" },
  { id: 4, name: "设备监控" },
  { id: 5, name: "政府市政" },
  { id: 6, name: "集成服务" },
  { id: 7, name: "环境保护" },
  { id: 8, name: "畜牧农业" },
  { id: 9, name: "金融行业" },
  { id: 10, name: "车联网后装" },
  { id: 11, name: "穿戴设备" },
  { id: 12, name: "能源电力" },
  { id: 13, name: "车联网前装" },
  { id: 14, name: "共享洗衣机" },
  { id: 15, name: "智能单车" },
  { id: 16, name: "消费电子类" },
  { id: 17, name: "共享汽车" },
  { id: 18, name: "共享充电宝" },
  { id: 19, name: "共享电动车" },
  { id: 20, name: "共享按摩椅" },
  { id: 21, name: "共享KTV" },
  { id: 22, name: "家电行业" },
  { id: 23, name: "视频监控" },
  { id: 24, name: "工业制造" },
  { id: 25, name: "国际业务" },
  { id: 26, name: "医疗设备" },
];

// 获取当前用户自己能看到的通道列表
export function getOwnOptionList(val) {
  return new Promise((resolve, reject) => {
    let _arr = [];
    this.$http
      .get("/sys/zyflowpool/ownerPassagewayList", {
        params: {
          operators: val,
        },
      })
      .then(({ data }) => {
        let { code, list } = data;
        if (data && code === 0) {
          if (list.length > 0) {
            list.map((item) => {
              _arr.push({
                id: item.id,
                name: item.name,
              });
            });
            resolve(_arr);
          } else {
            console.error("通道暂无数据，请添加");
            resolve(_arr);
          }
        } else {
          console.error("获取通道数据失败");
          resolve(_arr);
        }
      });
  });
}

// 套餐列表
export function packageList(name, operators, page, limit = 20) {
  return new Promise((resolve, reject) => {
    let _arr = [];
    this.$http
      .get("/sys/zypackage/list", {
        params: {
          name,
          operators,
          page,
          limit,
          type: 2,
          category: "",
          status: "",
          packageName: "",
        },
      })
      .then(({ data }) => {
        let code = data.code;
        if (data && code === 0) {
          resolve(data);
        } else {
          resolve({
            count: 0,
            data: [],
          });
        }
      });
  });
}
// 获取代理套餐列表
export function agentPackageList(operators, passagewayId, agentID) {
  return new Promise((resolve, reject) => {
    let _arr = [];
    let conf = new FormData();
    conf.append("operators", operators);
    conf.append("passagewayId", passagewayId);
    conf.append("agentID", agentID);
    conf.append("packageName", "");
    conf.append("category", "");
    conf.append("orSoStatus", "");
    this.$http
      .post("/sys/zypackage/agentPackageList", conf, {
        headers: { "content-type": "application/x-www-form-urlencoded" },
      })
      .then(({ data }) => {
        let code = data.code;
        if (data && code === 0) {
          resolve(data);
        } else {
          resolve({
            count: 0,
            data: [],
          });
        }
      });
  });
}
//发送验证码 发送验证码type参数说明：7 提现 8 修改提现密码 9 修改登陆密码 10 完善用户信息
export function getCodeFn(mobile, type) {
  return new Promise((resolve, reject) => {
    this.$http
      .post("/sys/sendCode", {
        mobile,
        type,
      })
      .then(({ data }) => {
        resolve(data);
      });
  });
}

// 密码校验
export function passwordValidate(str) {
  var rC = {
    lW: "[a-z]", //小写字母
    uW: "[A-Z]", //大写字母
    nW: "[0-9]", //汉字
    sW: "[\\u0020-\\u002F\\u003A-\\u0040\\u005B-\\u0060\\u007B-\\u007E]", //特殊字符
  };
  function Reg(str, rStr) {
    var reg = new RegExp(rStr);
    if (reg.test(str)) return true;
    else return false;
  }
  if (str.length < 8) {
    return false;
  } else {
    var tR = {
      l: Reg(str, rC.lW),
      u: Reg(str, rC.uW),
      n: Reg(str, rC.nW),
      s: Reg(str, rC.sW),
    };
    if (
      (tR.l && tR.u && tR.n) ||
      (tR.l && tR.u && tR.s) ||
      (tR.s && tR.u && tR.n) ||
      (tR.s && tR.l && tR.n)
    ) {
      //密码符合要求
      return true;
    } else {
      return false;
    }
  }
}
// base64编码
export const Base64 = {
  encode(str) {
    // first we use encodeURIComponent to get percent-encoded UTF-8,
    // then we convert the percent encodings into raw bytes which
    // can be fed into btoa.
    return btoa(
      encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode("0x" + p1);
        }
      )
    );
  },
  decode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  },
};

//文件转base64
export function fileToImgFn(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.readAsDataURL(file); // 读出 base64
    let dataURL;
    reader.onloadend = () => {
      // 图片的 base64 格式, 可以直接当成 img 的 src 属性值
      dataURL = reader.result;
      resolve(dataURL);
    };
  });
}

// 反馈建议列表
export const feedBackList = [
  { id: 9, name: "无法登录" },
  { id: 10, name: "卡片问题" },
  { id: 11, name: "订单问题" },
  { id: 12, name: "分润问题" },
  { id: 13, name: "套餐问题" },
  { id: 14, name: "回收卡片" },
  { id: 15, name: "分配卡片" },
  { id: 16, name: "新建客户" },
  { id: 17, name: "客户管理" },
  { id: 18, name: "个性化管理" },
  { id: 19, name: "API接口" },
  { id: 8, name: "其他建议" },
];
export function feedBackAction(val) {
  let item;
  item = feedBackList.filter((value) => {
    return value.id == val;
  });
  if (item.length > 0) {
    return item[0].name;
  }
  return "未知";
}

//工单反馈状态
export const fbType = [
  { id: 0, name: "待解决" },
  { id: 1, name: "待解决" },
  { id: 2, name: "解决中" },
  { id: 3, name: "已解决" },
];

//千分补空
export function get_thousand_num_null(num) {
  if (!Boolean(num)) {
    return "";
  }
  return num.toString().replace(/\d+/, function (n) {
    // 先提取整数部分
    return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
      // 对整数部分添加分隔符
      return $1 + ",";
    });
  });
}
export const Operators = [
  { id: "1", name: "电信" },
  { id: "2", name: "移动" },
  { id: "3", name: "联通" },
];
//行业类型
export const industryType = [
  { id: 1, name: "渠道用户" },
  { id: 2, name: "安防行业" },
  { id: 3, name: "教育行业" },
  { id: 4, name: "设备监控" },
  { id: 5, name: "政府市政" },
  { id: 6, name: "集成服务" },
  { id: 7, name: "环境保护" },
  { id: 8, name: "畜牧农业" },
  { id: 9, name: "金融行业" },
  { id: 10, name: "车联网后装" },
  { id: 11, name: "穿戴设备" },
  { id: 12, name: "能源电力" },
  { id: 13, name: "车联网前装" },
  { id: 14, name: "共享洗衣机" },
  { id: 15, name: "智能单车" },
  { id: 16, name: "消费电子类" },
  { id: 17, name: "共享汽车" },
  { id: 18, name: "共享充电宝" },
  { id: 19, name: "共享电动车" },
  { id: 20, name: "共享按摩椅" },
  { id: 21, name: "共享KTV" },
  { id: 22, name: "家电行业" },
  { id: 23, name: "视频监控" },
  { id: 24, name: "工业制造" },
  { id: 25, name: "国际业务" },
  { id: 26, name: "医疗设备" },
];

export function getIndustry(val) {
  let list = industryType.filter((item) => {
    return item.id == val;
  });
  return Boolean(list[0]) ? list[0].name : "未知";
}

export const payTypeList = [
  "银行转账",
  "支付宝",
  "微信",
  "签约提现",
  "签约提现2",
];
// 收款类型 1：银行转账 2：支付宝
export function typePay(value) {
  let val = "";
  switch (value) {
    case 1:
      val = "银行转账";
      break;
    case 2:
      val = "支付宝";
      break;
    case 3:
      val = "微信";
      break;
    case 4:
      val = "签约提现";
      break;
    case 5:
      val = "签约提现2";
      break;
    case 6:
      val = "签约提现3";
      break;
    case 8:
      val = "银行卡转账2";
      break;
    default:
      val = "";
      break;
  }
  return val;
}

export const bankList = [
  "中国工商银行",
  "中国建设银行",
  "中国银行",
  "中国农业银行",
  "交通银行",
  "招商银行",
  "中信银行",
  "中国光大银行",
  "中国邮政储蓄银行",
  "平安银行",
  "华夏银行",
  "中国民生银行",
];

export const cashInList = [
  { id: 0, name: "待审核" },
  { id: 1, name: "已发放" },
  { id: 2, name: "已驳回" },
  { id: 3, name: "发放中" },
  { id: 4, name: "失败" },
];

// * 提现状态 0：待审核 1：已发放 2：已驳回 3：发放中 4：失败
export function typeWithdrawStatus(value) {
  let val = "";
  switch (value) {
    case 0:
      val = "待审核";
      break;
    case 1:
      val = "已发放";
      break;
    case 2:
      val = "已驳回";
      break;
    case 3:
      val = "发放中";
      break;
    case 4:
      val = "失败";
      break;
    default:
      val = "";
      break;
  }
  return val;
}

//权限验证
export function hasPermission(key) {
  return store.state.user.permission.indexOf(key) !== -1 || false;
}

// 获取配置项
export function getInfo(params) {
  return new Promise((resolve, reject) => {
    this.$http
      .post("/sys/pay/queryInfo", params)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 获取客户列表
export function getSon() {
  const userData = [];
  this.$http.post("/sys/zycard/clientList").then(({ data }) => {
    let { code, userList } = data;
    if (data && code === 0) {
      if (userList !== null) {
        // 按照username进行排序
        userList = userList.sort(
          (a, b) => a.username.charCodeAt(0) - b.username.charCodeAt(0)
        );
        userList.map((item) => {
          userData.push({
            id: item.userId,
            name: item.username,
            realName: item.realName,
            title: `${item.username}(${item.realName})`,
          });
        });
      } else {
        console.error("客户列表数据为空");
      }
    } else {
      console.error("客户列表数据失败");
    }
  });
  return userData;
}

// 获取iccid区间数量
export function getIccids(start, end) {
  return new Promise((resolve, reject) => {
    this.$http
      .post(
        `/sys/zycard/selectIccidCount`,
        qs.stringify({ startId: start, endId: end })
      )
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function GetDateStr() {
  let d = new Date();
  let year = d.getFullYear();
  let month =
    d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
  let date = d.getDate() >= 10 ? d.getDate() : "0" + d.getDate();
  return year + "-" + month + "-" + date;
}

// 获取用户合同签署，实名认证相关信息
export function getContractByUser() {
  // isWeb 1 web 2 mobile
  return new Promise((resolve, reject) => {
    this.$http
      .get("/contract/getContractByUser")
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

// 获取用户合同签署，实名认证相关信息
// isWeb 1 web 2 mobile
export function ContractByUser(callBack, type = 1) {
  let conf = new FormData();
  conf.append("isWeb", 2);
  this.$http
    .post(`/contract/getContractSignedUrl`, conf, {
      headers: { "content-type": "multipart/form-data" },
    })
    .then(({ data }) => {
      if (type != 1) {
        callBack && callBack(data);
      } else {
        if (data.code !== 0) {
          return this.$toast(data.msg);
        }
        callBack && callBack(data.data);
      }
    })
    .catch((err) => {
      console.log("err :", err);
    });
}

//阿拉伯数字转中文数字
export function NoToChinese(num) {
  if (!/^\d*(\.\d*)?$/.test(num)) {
    console.log("Number is wrong!");
    return "Number is wrong!";
  }
  var str = num.toString();
  var chnNumChar = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  var chnUnitChar = [
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
  ];
  var chnStr = "";
  while (str.length > 0) {
    var tmpNum = chnNumChar[parseInt(str.substr(0, 1))];
    var tmpChar = chnUnitChar[str.length - 1];
    chnStr += chnStr.substr(-1, 1) == "零" && tmpNum == "零" ? "" : tmpNum;
    if (tmpNum != "零") {
      chnStr += tmpChar;
    }
    if (chnStr == "一十") {
      chnStr = "十";
    }
    str = str.substr(1);
    if (parseInt(str) === 0) {
      if (str.length >= 8) {
        if (chnStr.substr(-1, 1) != "亿") {
          chnStr += "亿";
        }
      } else if (str.length >= 5) {
        if (chnStr.substr(-1, 1) != "万") {
          chnStr += "万";
        }
      }
      str = "";
    }
  }
  return chnStr;
}

// 获取分配列表【page】
export function getDistributionList(page,limit=30, paramsData={}) {
    return new Promise((resolve,reject)=>{
        this.$http.get('/agent/card/batch/scan/list',{
            params:{
                page,
                limit,
                ...paramsData,
                // mobile:'13674128523'
            }
        },{
            noLoading:true
        }).then(({data})=>{
            if(data.code==0){
              resolve(data)
              return
            }
            this.$toast(data.msg)
            resolve({
                count:0,
                data:[]
            })
          }).catch(err => {
            reject(err)
          })
    })
}
// 获取明细列表
export function getDistributionRecordList(page,limit=30, paramsData={}) {
    return new Promise((resolve,reject)=>{
        this.$http.get('/agent/card/batch/scan/detail/list',{
            params:{
                page,
                limit,
                ...paramsData,
                // mobile:'13674128523'
            }
        },{
            noLoading:true
        }).then(({data})=>{
            if(data.code==0){
              resolve(data)
              return
            }
            this.$toast(data.msg)
            resolve({
                count:0,
                data:[]
            })
          }).catch(err => {
            reject(err)
          })
    })
}
// 通过
export function passThrough (id) {
    return new Promise((resolve,reject)=>{
        this.$http.post(`/agent/card/batch/scan/pass/${id}`,{}, {
            noLoading:true
        }).then(({data})=>{
            if(data.code==0){
              resolve(data)
              return
            }
            this.$toast(data.msg)
            reject()
          }).catch(err => {
            reject(err)
          })
    })
}
// 驳回
export function distributionReject ({reason, id}) {
    return new Promise((resolve,reject)=>{
        this.$http.post(`/agent/card/batch/scan/reject`,{
            id,
            rejectMsg: reason,
        }, {
            noLoading:true
        }).then(({data})=>{
            if(data.code==0){
              resolve(data)
              return
            }
            this.$toast(data.msg)
            reject()
          }).catch(err => {
            reject(err)
          })
    })
}


// WEBPACK FOOTER //
// ./src/utils/filter.js